module.exports = __webpack_public_path__ + "img/logo-drawthingsonline.1c043938.png";